var map = {
	"./slider-en/1.png": 4454,
	"./slider-en/10.png": 8948,
	"./slider-en/2.png": 2013,
	"./slider-en/3.png": 4532,
	"./slider-en/4.png": 795,
	"./slider-en/5.png": 290,
	"./slider-en/6.png": 6873,
	"./slider-en/7.png": 624,
	"./slider-en/8.png": 6983,
	"./slider-en/9.png": 3838,
	"./slider-tr/1.png": 5789,
	"./slider-tr/10.png": 7817,
	"./slider-tr/2.png": 902,
	"./slider-tr/3.png": 3567,
	"./slider-tr/4.png": 7072,
	"./slider-tr/5.png": 3977,
	"./slider-tr/6.png": 9442,
	"./slider-tr/7.png": 571,
	"./slider-tr/8.png": 6972,
	"./slider-tr/9.png": 6389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9810;